<template>
  <vue-excel-xlsx @click="dataVacia"
    :data="data"
    :columns="columns"
    :file-name="fileName"
    :file-type="fileType"
    :sheet-name="sheetName"
    class="buttonExport"
  >
    Exportar <i :class="icon"></i>
  </vue-excel-xlsx>
</template>

<script>
  export default {
    props: {
      data: {
        type: Array,
        required: true
      },
      columns: {
        type: Array,
        required: true
      },
      fileName: {
        type: String,
        default: 'Reporte'
      },
      sheetName: {
        type: String,
        default: 'Datos'
      },
      icon: {
        type: String,
        default: 'fas fa-download'
      }
    },
    data() {
      return {
        fileType: 'xlsx'
      }
    },
    methods:{
      dataVacia(){
        if(this.data.length === 0){
          this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'No hay data que exportar. Verrifica que la tabla contenga datos!',
          })
        }
      }
    }
  }
</script>

<style scoped>
  .buttonExport {
    width: 250px;
    border: none;
    color: #fff;
    display: flex;
    font-size: 17px;
    padding: 15px 20px;
    align-items: center;
    border-radius: 15px;
    background-color: #262626;
    justify-content: space-between;
  }
</style>
